import { Breadcrumb, Carousel } from '@cowsquare/design';
import { Link } from 'gatsby';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import defaultCover from '../../../../asset/defaultCover.jpg';
import { dateFormat } from '../../../../utils/dateFormat';
import { ArticleContent } from '../../../ArticleContent';
import { BreadcrumbWrapper } from '../../../BreadcrumbWrapper';
import { Section } from '../../../Section';
import PageNotFound from '../../error/404';

const GET_MEMBER_ONLY_NEW_RECORD = gql`
  query getMemberOnlyUserRecord($id: uuid!) {
    record: hkdutest_members_news_by_pk(id: $id) {
      id
      author {
        name
        email
      }
      name
      content
      cover_file {
        link
      }
      created_at
    }
  }
`;

const NewsContent = ({ id, uri }) => (
  <Query query={GET_MEMBER_ONLY_NEW_RECORD} variables={{ id }}>
    {({ data, loading }) => {
      if (!loading && !R.prop('record', data)) {
        return <PageNotFound />;
      }

      const record = R.propOr({}, 'record', data);
      const coverUrl = R.pathOr(defaultCover, ['cover_file', 'link'], record);
      const title = R.propOr('', 'name', record);
      const content = R.propOr('', 'content', record);
      const authorName = R.pathOr('', ['author', 'name'], record);
      const createdAt = R.propOr(null, 'created_at', record);
      const info = `${authorName} Published at ${createdAt ? dateFormat(createdAt) : ''}`;

      return (
        <Section>
          <Helmet>
            <title>{title} - HKDU Members Only</title>
          </Helmet>
          <Carousel>
            <Carousel.Slide backgroundImage={`url(${coverUrl})`} height={['150px', '300px']} />
          </Carousel>
          <BreadcrumbWrapper>
            <Breadcrumb>
              <Breadcrumb.Item linkProps={{ as: Link, to: R.replace(id, '', uri) }}>News</Breadcrumb.Item>
              <Breadcrumb.Item>{title}</Breadcrumb.Item>
            </Breadcrumb>
          </BreadcrumbWrapper>
          <ArticleContent title={title} info={info} content={content} />
        </Section>
      );
    }}
  </Query>
);

export default NewsContent;
